import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const SelectedTariffElements = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    row-gap: 8px;
`;

export const IncludedTariffElements = styled.div`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 8px;
`;

export const RecomendedTitle = styled.div`
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const SectionButton = styled(BaseButton)`
    margin-top: 8px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;
